/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type equipments_equipments$ref: FragmentReference;
declare export opaque type equipments_equipments$fragmentType: equipments_equipments$ref;
export type equipments_equipments = $ReadOnlyArray<{|
  +slug: ?string,
  +items: ?$ReadOnlyArray<?{|
    +slug: ?string,
    +score: ?number,
  |}>,
  +$refType: equipments_equipments$ref,
|}>;
export type equipments_equipments$data = equipments_equipments;
export type equipments_equipments$key = $ReadOnlyArray<{
  +$data?: equipments_equipments$data,
  +$fragmentRefs: equipments_equipments$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "equipments_equipments",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceStandardServiceItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SpaceStandardServices",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b66c5f11784d23576e2a6fbed2504228';

module.exports = node;
